import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function Comparison() {
  return <section className="py-14 sm:py-16 bg-charcoal relative" data-id="element-10">
      <div className="max-w-5xl mx-auto px-6" data-id="element-11">
        <div className="text-center mb-10" data-id="element-12">
          <div className="text-gold tracking-[0.2em] uppercase text-sm mb-4" data-id="element-13">
            A New Paradigm
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl text-ivory" data-id="element-14">
            Why This Works Differently
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-15">
          {/* UNHOOKED Column */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="bg-teal-dark/30 border border-teal/50 rounded-xl p-8 sm:p-10 relative overflow-hidden" data-id="element-16">
            <div className="absolute top-0 left-0 w-full h-1 bg-gold/60" data-id="element-17" />
            <h3 className="font-serif text-3xl text-ivory mb-8" data-id="element-18">UNHOOKED</h3>
            <ul className="space-y-6" data-id="element-19">
              {['Removes desire at the root', 'Focuses on dopamine understanding', 'No streak obsession', 'No shame-based motivation', 'Calm psychological framework', 'Brain rewiring approach'].map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-20">
                  <div className="mt-1 bg-teal/40 rounded-full p-1" data-id="element-21">
                    <CheckIcon className="w-4 h-4 text-gold" data-id="element-22" />
                  </div>
                  <span className="text-ivory/90 text-lg font-light" data-id="element-23">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* Traditional Column */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="bg-charcoal-light border border-charcoal-lighter rounded-xl p-8 sm:p-10" data-id="element-24">
            <h3 className="font-serif text-3xl text-ivory/50 mb-8" data-id="element-25">
              Traditional Methods
            </h3>
            <ul className="space-y-6" data-id="element-26">
              {['Depend on willpower', 'Create guilt cycles', 'Focus only on resisting urges', 'Make relapse feel catastrophic', 'Increase mental exhaustion'].map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-27">
                  <div className="mt-1 bg-charcoal rounded-full p-1" data-id="element-28">
                    <XIcon className="w-4 h-4 text-ivory/30" data-id="element-29" />
                  </div>
                  <span className="text-ivory/50 text-lg font-light" data-id="element-30">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}